// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__lS2Ht","box":"WorkspacesBox_box__2kvAI","node":"WorkspacesBox_node__3MCGN"};